import { Button, Group, NumberInput } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import React, { useState } from "react";

type ReprintProps = {
  label?: string;
  onReprint?: (id: number, orderStage?: number | string | undefined) => void;
  isOrderPage?: boolean;
  isSupplierOrderPage?: boolean;
};

const Reprint: React.FC<ReprintProps> = ({
  label = "Re‑Print",
  onReprint,
  isOrderPage = false,
  isSupplierOrderPage = false,
}) => {
  const [value, setValue] = useState<number | "">("");

  const handleReprint = () => {
    if (value === "" || isNaN(Number(value))) return;

    onReprint?.(Number(value));
  };
  const handleReprintOrder = (orderStage: number | string | undefined) => {
    if (value === "" || isNaN(Number(value))) return;

    onReprint?.(Number(value), orderStage);
  };

  return (
    <Group gap="xs">
      <NumberInput
        value={value ?? ""}
        onChange={(v) => {
          if (v === null || v === "") {
            setValue("");
          } else {
            setValue(Number(v));
          }
        }}
        min={1}
        hideControls
        w={80}
        placeholder="Record #"
      />

      {isOrderPage ? (
        <>
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={() => handleReprintOrder(0)}
          >
            {label} Picking
          </Button>
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={() => handleReprintOrder(1)}
          >
            {label} Packing
          </Button>
        </>
      ) : isSupplierOrderPage ? (
        <>
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={() => handleReprintOrder("prices")}
          >
            {label} Prices
          </Button>
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={() => handleReprintOrder("costing")}
          >
            {label} Costing
          </Button>
        </>
      ) : (
        <Button leftSection={<IconPrinter size={16} />} onClick={handleReprint}>
          {label}
        </Button>
      )}
    </Group>
  );
};

export default Reprint;
